package game.entity

import game.Game
import game.Room

class Score : Entity() {
    var value = 0

    override fun onTick(game: Game, room: Room) {
        sprite = game.getSpriteById("score-$value")
    }
}